import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router'
import { useSelector, useDispatch } from "react-redux";


import NotFound from "../404";
import PageChange from '../pageChange/index'
import { getDivice } from '../redux/featuer/divice/diviceUser'
import { optimizedGetPlatform } from '../helper/getPlatform'
import Marker from './marker';
import MarkerLess from './markerLess';

import toast from 'react-hot-toast'

import './index.css';

function IndexCamera() {
  const [isDataLoad, setIsDataLoad] = useState(false);
  const [data, setData] = useState(null)
  const params = useParams()
  const dispach = useDispatch()



  useEffect(() => {
    document.title = `مشاهده واقعیت افزوده - ${data ? data.data.user.name : "درحال بارگذاری"}`;
    getDataAR()
  }, [params])

  const getDataAR = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER}/api/nft/${params.username}/${params.url}`,
        {
          method: "GET",
        }
      )
      const data = await res.json()
      
      if (data.status === "success") {
        const platform = optimizedGetPlatform()
        dispach(getDivice(platform))
        setData({ status: 'ACTIVE', data: data.data })
        setIsDataLoad(true)
      } else if (data.status === "inactive") {
        setData({ status: 'INACTIVE', data: data.data })
        setIsDataLoad(true)
      } else {
        setIsDataLoad(true)
        toast.error(data?.msg);
      }

    } catch (err) {
      toast.error('server error');
      return;
    }

  }

  const checkRollShow = (dataCheck) => {

    if (!dataCheck.data) {
      return (<NotFound />)
    }

    if (dataCheck.status == 'ACTIVE') {
      if (dataCheck.data.types == "MARKERLESS") {
        return (markerLessHTML(dataCheck.data))
      }
      if (dataCheck.data.types == "MARKER") {
        return (markerHTML(dataCheck.data))
      }
    } else {
      return (disableHTML())
    }

  }

  const disableHTML = () => {
    return (
      <div className="flex items-center justify-center h-screen ">
        <div className="text-3xl text-center ">در حال حاضر غیر فعال می باشد</div>
      </div>
    )
  }

  const markerLessHTML = (dataMarker) => {
    return (
      <div className=''>
        <MarkerLess data={dataMarker} username={dataMarker.user.username} />
      </div>
    )
  }

  const markerHTML = (dataMarker) => {
    return (
      <div className='container-image'>
        <Marker data={dataMarker} username={dataMarker.user.username} />
      </div>
    )
  }

  return (
    <>
      {isDataLoad ? (
        <>
          {checkRollShow(data)}
        </>
      ) : (
        <PageChange />
      )}
    </>
  );
}





export default IndexCamera;






